import { APP_BASE_HREF } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from "ngx-toastr";
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard, RoleGuard, TokenInterceptorService, UserService, GlobalErrorHandler, TypeTiersService } from './shared/services';
import { EvenementService } from './shared/services/evenement.service';



@NgModule({
  declarations: [AppComponent, ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-bottom-right',
      enableHtml: true,
    })
  ],
  bootstrap: [AppComponent],
  providers: [AuthGuard, RoleGuard, UserService, TypeTiersService, EvenementService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },{
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    }, {
      provide: APP_BASE_HREF,
      useValue: '/',
    }],
})


export class AppModule {
}
